import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { Grid, Card, CardHeader, CardContent, Typography } from '@material-ui/core';
import { Form } from 'formik';
import Select from '../../../../../../components/Select';

import { loadClient } from '../../BasicInfo/store/thunk';
import { clearTypePricesLinkErrors } from '../../LinkTable/store/actions';

import { convertToOptions } from '../../../../../../helpers/converters';

import { useStyles } from './styles';

export default function LinkServices({ formikInjectProps }) {
  const dispatch = useDispatch();

  const classes = useStyles();

  const linkServicesErrors = useSelector(state => state.clientRegistration.linkServices.errors);
  const filters = useSelector(state => state.filters.selects);

  const availableServices = convertToOptions(['services'], filters)
    .map(service => {
      return {
        value: service?.serviceId,
        label: service?.description
      }
    })
    .filter(service => !!service?.value)
    .concat({
      value: '0',
      label: '--'
    })
    .reverse();

  const userId = useSelector(state => state.profile.userId);
  const establishmentId = useSelector(state => state.businessInfo.establishmentId);
  const { clientId } = useSelector(state => state.clientRegistration.basicInfo);

  useEffect(() => {
    dispatch(clearTypePricesLinkErrors());

    (async () => {
      const params = {
        userId,
        establishmentId,
        clientId
      }

      const { servicesLink } = await dispatch(loadClient(params));

      formikInjectProps.setFieldValue('servicesLink', Array.isArray(servicesLink) ? servicesLink : [servicesLink]);
    })();
  }, []);

  return (
    <Grid item md={12} xs={12}>
      <Card>
        <CardHeader
          style={{ backgroundColor: '#022A5C', padding: '8px' }}
          title={
            <Typography gutterBottom variant="h6" className={classes.root}>
              Vincular serviços
            </Typography>
          }
        />
        <CardContent>
          <Form>
            <Grid container spacing={3} direction="row" alignItems="stretch">
              <Grid item md={8} xs={12}>
                <Select
                  multiple
                  name="servicesLink"
                  label="Vincular serviços"
                  options={availableServices}
                  value={formikInjectProps.values.servicesLink}
                  error={formikInjectProps.errors.servicesLink || !!linkServicesErrors?.servicesLink}
                  helperText={formikInjectProps.errors.servicesLink || linkServicesErrors?.servicesLink}
                  onChange={e => {
                    formikInjectProps.setFieldValue(
                      'servicesLink',
                      e.target.value
                    );
                  }}
                />
              </Grid>
            </Grid>
          </Form>
        </CardContent>
      </Card>
    </Grid>
  );
}

LinkServices.defaultProps = {
  formikInjectProps: {
    handleChange: () => {},
    setFieldValue: () => {},
    values: {
      name: '',
      email: ''
    },
    errors: {
      name: false,
      email: false
    }
  }
}

LinkServices.propTypes = {
  formikInjectProps: PropTypes.shape()
};